import React from 'react'
import Styles from './WeekPayment.module.css'

export default class WeekTable extends React.Component {
    
    render() {
        return (
            <section className={Styles.week}>
                <h2>{`Semana ${this.props.week.weekAndYear}`} --- 
                    {`Cajas: ${this.props.week.total.toFixed(1)}`}
                </h2>
                {this.props.week.employees.map((employee, key, fruta) => {
                    return <Employee fruta={fruta} employee={employee} key={key}/>
                })}
            </section>
        )
    }
}

class Employee extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tableVisible: false,
        }
    }
    toggleTable = () => {
        this.setState({
            tableVisible: !this.state.tableVisible
        })
    }
    renderZarzamora = (activities) => {
        return (
            <>
            <div className="tabla">
            <h2 className={Styles.title}>Pisca Zarzamora</h2>
                <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>Variedad</th>
                            <th>Sector</th>
                            <th>Cajas</th>
                        </tr>
                        {activities.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.fecha}</td>
                                <td>{activity.variedad}</td>
                                <td>{activity.sector}</td>
                                <td>{activity.totalCajas}</td>
                            </tr>
                        )}
                </tbody></table>
                </div>
            </>
        )
    }
    renderFrambuesa = (activities) => {
        return (
            <>
                <div className="tabla">
                <h2 className={Styles.title}>Pisca Frambuesa</h2>
                <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>Variedad</th>
                            <th>Sector</th>
                            <th>Botes</th>
                            <th>Cajas</th>
                        </tr>
                        {activities.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.fecha}</td>
                                <td>{activity.variedad}</td>
                                <td>{activity.sector}</td>
                                <td>{activity.totalBotes}</td>
                                <td>{activity.totalCajas}</td>
                            </tr>
                        )}
                </tbody></table>
                </div>
            </>
        )
    }
    
    render() {
        return (
            <div className={Styles.employee}>
                <div className={Styles.row} onClick={this.toggleTable}>
                    <p>{`${this.props.employee.employee}`}</p>
                    <p>{`Cajas: ${this.props.employee.totalEmpleado.toFixed(1)}`}</p>
                </div>
                {
                    this.state.tableVisible
                        ? this.props.employee.activities.length > 0
                            ? this.renderFrambuesa(this.props.employee.activities)
                            : null
                        : null
                }
                {
                    this.state.tableVisible
                        ? this.props.employee.harvestActivities.length > 0
                            ? this.renderZarzamora(this.props.employee.harvestActivities)
                            : null
                        : null
                }
            </div>
        )
    }
}